import React, { createContext, useCallback, useContext, useState } from "react";
import { Toaster } from "./widgets";

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const push = useCallback((msg, kind = "ok") => {
    const id = Math.random().toString(36).slice(2);
    setToasts((t) => [...t, { id, msg, kind }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 2400);
  }, []);
  return (
    <ToastCtx.Provider value={push}>
      {children}
      <Toaster toasts={toasts} />
    </ToastCtx.Provider>
  );
}
export const useToast = () => useContext(ToastCtx);
